

























import { PersonLabelEnum } from "@/lib/enum/person-label.enum";
import { emailRule } from "@/lib/rules/contactRule";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IPersonEmail } from "@/models/person-email.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";

@Component({
  components: { Debug },
  filters: {}
})
export default class PersonEmailForm extends mixins(RulesMixin) {
  readonly PersonLabelEnum = PersonLabelEnum;

  @Prop()
  value!: IPersonEmail;

  get emailRule() {
    return [emailRule()];
  }
}
